import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SafeHtmlPipe } from './shared/pipes/safehtml';
import { ScoutViewPipelinePipe } from './shared/pipes/sv-pipeline';
import { HighlightPipe } from './shared/pipes/highlightPipe';
import { ResearchComponentsCoreModule } from '@corteva-research/ngx-components-core';
import { ResearchComponentsMsalIntegrationModule } from '@corteva-research/ngx-components-msal-integration';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { DatePipe } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { TooltipModule } from 'primeng/tooltip';

import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';

import { SliderModule } from 'primeng/slider';

import { CheckboxModule } from 'primeng/checkbox';
import { PanelModule } from 'primeng/panel';

import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { ToastrModule } from 'ngx-toastr';

import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { UserGroupsComponent } from './components/user-groups/user-groups.component';
import { SensorGroupsComponent } from './components/sensor-groups/sensor-groups.component';
import { CreateUpdateSensorgroupComponent } from './components/sensor-groups/create-update-sensorgroup/create-update-sensorgroup.component';
import { SensorGroupService } from './shared/services/sensorgroup.service';
import { TriggerSettingsComponent } from './components/trigger-settings/trigger-settings.component';
import { TriggerService } from './components/trigger-settings/trigger.service';
import { ActionQueueService } from '@services/actionQueue.service';
import { MapReadingsComponent } from './components/map-readings/map-readings.component';
import { MapReadingsService } from './components/map-readings/mapreadings.service';
import { SensorReadingsComponent } from './components/sensor-readings/sensor-readings.component';
import { SensorReadingsService } from './components/sensor-readings/sensor-readings.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardEventsService } from './components/dashboard/dashboard.service';
import { RegisterDevicesComponent } from './components/register-devices/register-devices.component';
import { DeviceService } from '@services/device.service';
import { ScoutviewService } from '@services/scoutview.service';
import { MediaPipelineService } from '@services/mediaPipeline.service';
import { KigScannerModule } from './shared/components/kig-scanner/kig-scanner.component';
import { UserService } from '@services/user.service';
import { IsalService } from '@services/isal.service';
import { ImportService } from '@services/import.service';
import { KigAuthGuard } from '@services/auth.guard';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SelectDropDownModule } from 'ngx-select-dropdown';

import { SensorService } from '@services/sensor.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { LoadingModule } from './shared/components/loading/loading.component';
import { GraphApiService } from '@services/graph-api.service';
import { PostLoginComponent } from './components/post-login/post-login.component';
import { SensorsComponent } from './components/sensors/sensors.component';
import { MessagesComponent } from './components/messages/messages.component';
import { AppMessageService } from '@services/message.service';
import { SettingService } from '@services/setting.service';
import { GlobalSearchService } from '@services/globalSearch.service';
import { GlobalSearchComponent } from './components/home/global-search/global-search.component';
import { AIService } from '@services/ai.service';
import { UsersComponent } from './components/users/users.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { SensorConditionsEvalModalComponent } from './components/trigger-settings/sensor-conditions-eval-modal/sensor-conditions-eval-modal.component';
import { LogsModalComponent } from './components/trigger-settings/logs-modal/logs-modal.component';
import { ImportLogsModalComponent } from './components/import/import-logs-modal/import-logs-modal.component';
import { EditEventsAndActionsModalComponent } from './components/trigger-settings/edit-events-and-actions-modal/edit-events-and-actions-modal.component';
import { InvokeResultsModalComponent } from './components/trigger-settings/invoke-results-modal/invoke-results-modal.component';
import { MiniChartComponent } from './components/trigger-settings/mini-chart/mini-chart.component';
import { ActionQueuesComponent } from './components/trigger-queues/action-queues.component';
import { EditActionQueueComponent } from './components/trigger-queues/edit-action-queues/edit-action-queues.component';
import { ViewActionQueueComponent } from './components/trigger-queues/view-action-queues/view-action-queues.component';
import { EvaluateTimerEventResultsModalComponent } from './components/trigger-settings/evaluate-timer-event-results-modal/evaluate-timer-event-results-modal.component';
import { ManualFloodIrrigationModalComponent } from './components/trigger-settings/manual-flood-irrigation-modal/manual-flood-irrigation-modal.component';
import { EditEventConditionThresholdComponent } from './components/trigger-settings/edit-event-condition-threshold/edit-event-condition-threshold.component';
import { ImportComponent } from './components/import/import.component';
import { IsalComponent } from './components/dashboard/isal/isal.component';
import { DashboardAlertBadgeComponent } from './components/dashboard/dashboard-alert-badge/dashboard-alert-badge.component';
import { DashboardCreateWizardComponent } from './components/dashboard/dashboard-create-wizard/dashboard-create-wizard.component';
import { WizardStepperComponent } from './components/dashboard/dashboard-create-wizard/wizard-stepper/wizard-stepper.component';
import { WizardStepCreateTypeComponent } from './components/dashboard/dashboard-create-wizard/wizard-step-create-type/wizard-step-create-type.component';
import { ChartFavoriteWizardFlowComponent } from './components/dashboard/dashboard-create-wizard/chart-favorite-flow/chart-favorite-wizard-flow.component';
import { NotificationWizardFlowComponent } from './components/dashboard/dashboard-create-wizard/notification-flow/notification-wizard-flow.component';
import { ScoutviewComponent } from './components/scoutview/scoutview.component';
import { SensorDataModalComponent } from './components/sensors/sensor-data-modal/sensor-data-modal.component';
import { ExportDataModalComponent } from './components/sensors/export-data-modal/export-data-modal.component';
import { StatsReadingsModalComponent } from './components/review-readings/stats-readings-modal/stats-readings-modal.component';
import { ChartReadingsEchartModalComponent } from './components/review-readings/chart-readings-echart-modal/chart-readings-echart-modal.component';
import { MinMaxScaleModalComponent } from './components/review-readings/chart-readings-echart-modal/min-max-scale-modal/min-max-scale-modal.component';
import { ChartLabelEditorModalComponent } from './components/review-readings/chart-readings-echart-modal/chart-label-editor-modal/chart-label-editor-modal.component';
import { SeriesTypeModalComponent } from './components/review-readings/chart-readings-echart-modal/series-type-modal/series-type-modal.component';
import { ChartTileComponent } from './components/review-readings/chart-tile/chart-tile.component';
import { ImageFavoriteComponent } from './shared/components/image-favorite/image-favorite.component';
import { ImageLabelEditorModalComponent } from './shared/components/image-favorite/image-label-editor-modal/image-label-editor-modal.component';
import { ImageFavoriteEditModalComponent } from './shared/components/image-favorite/image-favorite-edit-modal/image-favorite-edit-modal.component';
import { ImageFavoriteWizardFlowComponent } from './components/dashboard/dashboard-create-wizard/image-favorite-flow/image-favorite-wizard-flow.component';
import { ImageFavoriteService } from '@services/imageFavorite.service';
import { MapFavoriteService } from '@services/mapFavorite.service';
import { MapFavoriteComponent } from './shared/components/map-favorite/map-favorite.component';
import { MapFavoriteTileComponent } from './shared/components/map-favorite-tile/map-favorite-tile.component';
import { MapFavoriteBarComponent } from './shared/components/map-favorite-bar/map-favorite-bar.component';
import { MapFavoriteWizardFlowComponent } from './components/dashboard/dashboard-create-wizard/map-favorite-flow/map-favorite-wizard-flow.component';
import { SensorReadingSelectorComponent } from './shared/components/sensor-reading-selector/sensor-reading-selector.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { TableReadingsModalComponent } from './components/review-readings/table-readings-modal/table-readings-modal.component';
import { AiReadingsModalComponent } from './components/review-readings/ai-readings-modal/ai-readings-modal.component';
import { ExportReadingsModalComponent } from './components/review-readings/export-readings-modal/export-readings-modal.component';
import { HomeComponent } from './components/home/home.component';
import { CameraSettingsComponent } from './components/scoutview/camera-settings/camera-settings.component';
import { VirtualSensorModalComponent } from './components/sensors/virtual-sensor-modal/virtual-sensor-modal.component';
import { SvLazyThumbnailDirective } from './shared/directives/sv-lazy-thumbnail.directive';
import { ResizableModalDirective } from './shared/directives/resizable-modal.directive';
import { MediaPipelineComponent } from './components/scoutview/media-pipeline/media-pipeline.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DragulaModule } from 'ng2-dragula';
import { QuickCreateSensorgroupComponent } from './components/sensor-groups/quick-create-sensorgroup/quick-create-sensorgroup.component';
import { ChangeLogNotesComponent } from './components/messages/changelog-notes/changelognotes.components';
import { UpgradeManagerComponent } from './components/register-devices/upgrade-manager/upgrade-manager.component';
import { FileStorageService } from '@services/fileStorage.service';
import { ImportSensorComponent } from './components/sensors/import-sensor-modal/import-sensor-modal.component';
import { SensorLabelComponent } from './components/sensors/sensor-label-modal/sensor-label-modal.component';
import { ImageModule } from 'primeng/image';
import {GalleriaModule} from 'primeng/galleria';
import { DataShareService } from '@services/dataShare.service';
import { UserDetailsComponent } from './components/users/user-details/user-details.component';
import { SensorAssociationsModalComponent } from './components/sensors/sensor-associations-modal/sensor-associations-modal.component';
import { IrrigationStatsModalComponent } from './components/register-devices/irrigation-stats/irrigation-stats.component';
import { ReviewReadingsComponent } from './components/review-readings/review-readings.component';
import { SensorCalibrationComponent } from './components/sensors/sensor-calibration/sensor-calibration.component';
import { SensorCalibrationHistoryComponent } from './components/sensors/sensor-calibration-history/sensor-calibration-history.component';

export const loggerCallback = (logLevel, message, piiEnables) => {
  console.log(message);
};

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    ScoutViewPipelinePipe,
    HighlightPipe,
    SvLazyThumbnailDirective,
    ResizableModalDirective,
    UserGroupsComponent,
    SensorGroupsComponent,
    CreateUpdateSensorgroupComponent,
    QuickCreateSensorgroupComponent,
    TriggerSettingsComponent,
    SensorReadingsComponent,
    MapReadingsComponent,
    DashboardComponent,
    RegisterDevicesComponent,
    UpgradeManagerComponent,
    PostLoginComponent,
    SensorsComponent,
    SensorLabelComponent,
    ImportSensorComponent,
    MessagesComponent,
    ChangeLogNotesComponent,
    UsersComponent,
    UserDetailsComponent,
    ImportComponent,
    SensorConditionsEvalModalComponent,
    LogsModalComponent,
    ImportLogsModalComponent,
    EditEventsAndActionsModalComponent,
    InvokeResultsModalComponent,
    EvaluateTimerEventResultsModalComponent,
    ManualFloodIrrigationModalComponent,
    EditEventConditionThresholdComponent,
    IsalComponent,
    DashboardAlertBadgeComponent,
    DashboardCreateWizardComponent,
    WizardStepperComponent,
    WizardStepCreateTypeComponent,
    ChartFavoriteWizardFlowComponent,
    NotificationWizardFlowComponent,
    ScoutviewComponent,
    SensorDataModalComponent,
    ExportDataModalComponent,
    StatsReadingsModalComponent,
    ChartReadingsEchartModalComponent,
    MinMaxScaleModalComponent,
    ChartLabelEditorModalComponent,
    SeriesTypeModalComponent,
    ChartTileComponent,
    ImageFavoriteComponent,
    MapFavoriteComponent,
    MapFavoriteTileComponent,
    MapFavoriteBarComponent,
    MapFavoriteWizardFlowComponent,
    SensorReadingSelectorComponent,
    ImageLabelEditorModalComponent,
    ImageFavoriteEditModalComponent,
    ImageFavoriteWizardFlowComponent,
    MiniChartComponent,
    ActionQueuesComponent,
    EditActionQueueComponent,
    ViewActionQueueComponent,
    TableReadingsModalComponent,
    AiReadingsModalComponent,
    ExportReadingsModalComponent,
    HomeComponent,
    GlobalSearchComponent,
    CameraSettingsComponent,
    VirtualSensorModalComponent,
    MediaPipelineComponent,
    SensorAssociationsModalComponent,
    IrrigationStatsModalComponent,
    ReviewReadingsComponent,
    SensorCalibrationComponent,
    SensorCalibrationHistoryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    ToggleSwitchModule,
    KigScannerModule,
    NgxDaterangepickerMd.forRoot(),
    LoadingModule.forRoot(),
    SelectDropDownModule,
    NgSelectModule,
    QRCodeComponent,
    MsalModule,
    NgMultiSelectDropDownModule.forRoot(),
    BaseChartDirective,
    NgxEchartsModule.forRoot({ echarts }),
    ResearchComponentsCoreModule.forRoot('kig-ui'),
    ResearchComponentsMsalIntegrationModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    TableModule,
    InputTextModule,
    ListboxModule,
    TooltipModule,
    SliderModule,
    CheckboxModule,
    PanelModule,
    BlockUIModule,
    ProgressSpinnerModule,
    ToastModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ConfirmDialogModule,
    GoogleMapsModule,
    DragDropModule,
    DragulaModule.forRoot(),
    ImageModule,
    GalleriaModule
  ],
  providers: [
    DatePipe,
    MsalService,
    ConfirmationService,
    MessageService,
    UserService,
    IsalService,
    ImportService,
    SensorGroupService,
    DeviceService,
    ScoutviewService,
    MediaPipelineService,
    AppMessageService,
    SettingService,
    GlobalSearchService,
    AIService,
    SensorService,
    TriggerService,
    ActionQueueService,
    KigAuthGuard,
    MapReadingsService,
    SensorReadingsService,
    ImageFavoriteService,
    MapFavoriteService,
    DashboardEventsService,
    AppComponent,
    GraphApiService,
    FileStorageService,
    DataShareService,

    provideCharts(withDefaultRegisterables()),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: '[data-theme="dark"]'
        }
      }
    }),
    // NOTE: MsalInterceptor is already provided by ResearchComponentsMsalIntegrationModule.
    // Registering it here as well ran token acquisition twice per request, which could kick
    // off two concurrent interactive redirects -> BrowserAuthError: interaction_in_progress.

  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
[];
